import * as React from "react";
import { UitkLayoutFlex, UitkLayoutFlexItem } from "uitk-react-layout-flex";
import { UitkSheet } from "uitk-react-sheet";
import { UitkFigure, UitkImage } from "uitk-react-images";
import { UitkLink } from "uitk-react-link";
import { TrackedLink } from "src/components/utility/analytics/TrackedLink";
import { LocalizedComponentClass, withLocalization } from "bernie-l10n";
import { useLocalization } from "@shared-ui/localization-context";
import { HotelSearchLinkBuilder } from "components/utility/HotelSearchLinkBuilder/HotelSearchLinkBuilder";

export interface MapPoiSheetProps {
  id: string;
  title?: string;
  distance?: string;
  photoUrl?: string;
  description?: string;
  isVisible?: boolean;
}

export const MapPoiSheet = withLocalization((props: MapPoiSheetProps) => {
  const { id, title, photoUrl, description, isVisible } = props;
  const { formatText } = useLocalization();

  if (!title || !isVisible) {
    return null;
  }

  return (
    <UitkSheet className="MapHotelCard" isVisible={isVisible}>
      <UitkLayoutFlex wrap="nowrap" className="uitk-cell">
        <MapSheetImage photoUrl={photoUrl} photoAlt={title} />
        <UitkLayoutFlexItem className="all-y-padding-three all-x-padding-three">
          <div>
            <div className="uitk-type-400 uitk-type-bold">{title}</div>
            {!!description && <div className="all-t-padding-half all-b-padding-one">{description}</div>}
            <UitkLink inline={true}>
              <TrackedLink
                moduleName="Maps"
                href={new HotelSearchLinkBuilder().withDaysInFuture().withStayLength().withRegionId(id).build()}
                linkName="poiSheet"
                rfrr="CTA.HSR"
              >
                {formatText("maps.sheets.poi.seeNearby")}
              </TrackedLink>
            </UitkLink>
          </div>
        </UitkLayoutFlexItem>
      </UitkLayoutFlex>
    </UitkSheet>
  );
}) as LocalizedComponentClass<MapPoiSheetProps>;

interface MapSheetImageModel {
  photoUrl?: string;
  photoAlt?: string;
}

export const MapSheetImage = ({ photoUrl, photoAlt }: MapSheetImageModel) => {
  if (!photoUrl) {
    return null;
  }

  return (
    <UitkLayoutFlexItem minWidth="quarter_width">
      <div>
        <UitkFigure className="all-image-fit-cover">
          <UitkImage src={photoUrl} alt={photoAlt} placeholderImage={true} />
        </UitkFigure>
      </div>
    </UitkLayoutFlexItem>
  );
};

export default MapPoiSheet;
